<template>
  <v-navigation-drawer
    class="shopping-cart-widget"
    :value="open"
    @input="(v) => (open = v)"
    :permanent="!mdAndDown && open"
    :temporary="mdAndDown && open"
    width="460px"
    height="100%"
    hide-overlay
    :mini-variant="lgAndDown"
    :mini-variant-width="shoppingCartWidth"
    right
    app
  >
    <v-card height="100%" flat tile>
      <div
        class="
          white
          d-flex
          justify-center justify-sm-space-between
          align-center
          px-5 px-lg-7
          py-2 py-md-4
          text-center
          shopping-cart-widget-title
        "
      >
        <div
          class="
            grey--text
            text--darken-4 text-body-1 text-md-h6 text-center
            font-weight-medium
          "
        >
          Carrinho
        </div>

        <v-btn
          @click="open = false"
          class="ml-n2 ml-sm-0 mr-sm-n2 shopping-cart-widget-close"
          color="secondary"
          icon
        >
          <v-icon :size="smAndDown ? 20 : ''">
            {{ xsOnly ? "fa-chevron-left" : "fa-chevron-right" }}
          </v-icon>
        </v-btn>
      </div>

      <div
        class="shopping-cart-widget-items"
        :class="{ 'has-items': items.length }"
      >
        <div class="scrollable">
          <div class="px-5 px-lg-7">
            <template v-if="items.length">
              <template v-if="pricedItems.length">
                <template v-for="(item, keyItems) in pricedItems">
                  <shopping-cart-item
                    :key="keyItems"
                    v-on:remove="remove(item)"
                    :content="item"
                  />
                </template>
              </template>

              <div v-if="items.length" class="d-flex align-center pt-4">
                <div
                  v-if="config.delivery_fee"
                  class="text-body-2 text-lg-body-1 grey--text"
                >
                  Taxa de entrega:
                  <span class="font-weight-bold">
                    {{ formatPrice(config.delivery_fee) }}
                  </span>
                </div>

                <div
                  class="text-body-2 text-lg-body-1 font-weight-medium ml-auto"
                >
                  Total:
                  <span
                    class="
                      secondary--text
                      font-weight-bold
                      shopping-cart-widget-price
                    "
                  >
                    {{ totalPrice }}
                  </span>
                </div>
              </div>

              <template v-if="noPricedItems.length">
                <div
                  class="primary--text text-subtitle-1 font-weight-bold mt-6"
                >
                  Outros
                </div>
                <template v-for="(item, keyItems) in noPricedItems">
                  <shopping-cart-item
                    :key="keyItems + pricedItems.length"
                    v-on:remove="remove(item)"
                    :content="item"
                  />
                </template>
              </template>
            </template>

            <div v-else>
              <img
                class="d-block"
                src="../../assets/emptycart.png"
                width="100%"
              />

              <div class="primary--text text-center mt-3 font-weight-bold">
                Seu carrinho está vazio!
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="white px-3 px-sm-5 px-lg-7 py-6 shopping-cart-widget-submit">
        <v-btn
          class="text-body-2 text-none px-sm-8"
          :disabled="!items.length"
          @click="finishShoppingCart"
          target="_blank"
          color="primary"
          height="45px"
          depressed
          block
          tile
        >
          <v-icon class="mr-2" size="20"> fab fa-whatsapp </v-icon>
          <span class="font-weight-medium">Finalizar Pedido no WhatsApp</span>
        </v-btn>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import ShoppingCartItem from "./ShoppingCartItem.vue";
import formatPrice from "../util/formatPrice";
import { getWhatsappLinkFromPhone } from "../util/getWhatsappLinkFromPhone";

export default {
  data: () => ({
    gtmSubmitEvent: "finish_shopping_cart",
  }),
  created() {
    this.$rest("config").get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    shoppingCartWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
        case "md":
        case "sm":
          return "360px";
        default:
          return "100%";
      }
    },
    config() {
      return this.$rest("config").item;
    },
    items() {
      return this.$shoppingCart.container.items;
    },
    pricedItems() {
      return this.items.filter(({ price }) => price);
    },
    noPricedItems() {
      return this.items.filter(({ price }) => !price);
    },
    totalPrice() {
      const price =
        this.$shoppingCart.container.items.reduce(
          (r, { quant, price }) => r + price * quant,
          0
        ) + parseFloat(this.config.delivery_fee ? this.config.delivery_fee : 0);
      return price ? formatPrice(price) : "Sob Consulta";
    },
    open: {
      get() {
        return this.$shoppingCart.open;
      },
      set(v) {
        this.$shoppingCart.open = v;
      },
    },
    lgAndDown() {
      return this.$vuetify.breakpoint.lgAndDown;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatPrice,
    async finishShoppingCart() {
      const products = this.items.map(
        ({ state: { id, observations, quant, variant } }) => ({
          id,
          observations,
          quant,
          variant,
        })
      );

      const data = await this.$rest("orders").post({
        data: {
          products,
        },
      });

      if (window.dataLayer && this.gtmSubmitEvent) {
        window.dataLayer.push({ event: this.gtmSubmitEvent });
      }

      const text = encodeURIComponent(data.text);

      const url =
        getWhatsappLinkFromPhone(this.config.whatsapp) + "?text=" + text;

      window.open(url, "_self");

      this.clear();
    },
    remove(item) {
      this.$shoppingCart.container.remove(item);
    },
    clear() {
      this.$shoppingCart.container.clear();
    },
    fillString(count, caractere) {
      if (count <= 0) return " ";

      return Array(count).fill(caractere).join("");
    },
  },
  watch: {
    open(v) {
      let tagHtml = document.getElementsByTagName("html")[0];

      if (v) tagHtml.classList.add("shopping-cart");
      else tagHtml.classList.remove("shopping-cart");
    },
  },
  components: {
    ShoppingCartItem,
  },
};
</script>

<style lang="scss" scoped>
.shopping-cart-widget::v-deep {
  .v-navigation-drawer__content {
    overflow: hidden !important;
  }
}

.shopping-cart-widget {
  box-shadow: -20px 0 30px rgba(0, 0, 0, 0.05) !important;

  &-title {
    left: 0;
    height: 70px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 2;

    @media screen and (max-width: 960px) {
      height: 56px;
    }
  }

  &-close {
    @media screen and (max-width: 600px) {
      left: 20px;
      position: absolute;
    }
  }

  &-items {
    height: 100%;
    padding-bottom: 84px;
    padding-top: 70px;

    @media screen and (max-width: 960px) {
      padding-top: 56px;
    }

    &.has-items {
      padding-bottom: 93px;
    }

    .scrollable {
      height: 100%;
      overflow-y: auto;

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: var(--v-primary-base-lighten1);
      }

      &::-webkit-scrollbar {
        width: 4px;
        background-color: var(--v-primary-base-lighten1);
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--v-primary-darken1);
        border-radius: 4px;
      }
    }

    > * {
      margin-bottom: 12px;
    }
  }

  &-price {
    border: 1px solid var(--v-secondary-base);
    border-radius: 4px;
    padding: 3px 6px;
  }

  &-submit {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
  }
}
</style>
